import React from 'react';
import WidgetList from '../../editor/components/WidgetList';
import { compose, branch, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import { withAllWidgets } from '../hoc/widgets';
import { GROUP_KEY, ALL_WIDGETS } from '../constants';

const AllWidgetsOverview = compose(
    connect(() => ({
        allwidgets: 'all',
        groupBy: GROUP_KEY,
        filter: ([k]) => ALL_WIDGETS.indexOf(k) !== -1,
        sortBy: ([k]) => ALL_WIDGETS.indexOf(k),
        propsForWidgets: w => ({ demo: true, name: w.name }),
    })),
    branch(({ template }) => !template, renderComponent(() => <div>no template...</div>)),
)(withAllWidgets(WidgetList));

export default AllWidgetsOverview;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/AllWidgetsOverview.js
 **/